import { useQuery } from '@apollo/client';
import { GET_FINAL_MILE_CARRIER_OPTIONS, FinalMileCarrierOption } from '../graphql/queries/getFinalMileCarrierOptions';

/**
 * 获取尾程商选项的 Hook
 * @param includeSwiftX 是否包含 SWIFTX (默认包含)
 */
export const useFinalMileCarrierOptions = (includeSwiftX: boolean = true) => {
  const { data, loading, error } = useQuery(GET_FINAL_MILE_CARRIER_OPTIONS, {
    variables: { includeSwiftX },
    fetchPolicy: 'cache-first', // 使用缓存优先策略，因为尾程商列表不会频繁变化
  });

  const options = data?.getFinalMileCarrierOptions || [];

  return {
    options: options as FinalMileCarrierOption[],
    loading,
    error,
  };
};
